/**
 * ViewsIf directive
 * remove element from DOM depending on views
 *
 * example :  *viewsIf="{pageName: 'search', path: 'fields.booking.xHost'}
 * @param {event} focus
 */


import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ViewsService } from "./views.service";

@Directive({
    selector: '[viewsIf]'
})
export class ViewsIfDirective {
    @Input('viewsIf')
    public path: string;

    @Input('viewsPage')
    public pageName: string;

    public canShow: boolean;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private views: ViewsService) {
    }


    public ngAfterViewInit(): void {

        this.views.view.subscribe((view) => {
            const showMe = this.views.canShow(view, this.pageName, this.path);

            if (showMe) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        });

    }


}
